/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'antd-mobile'
import { message } from 'antd'
import * as _ from 'lodash'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { AdvDialogStyle, SelectTypeModal } from '@styles/modal'
import { LS_SPORT_ID, SPORT_ID } from 'adv-protocol/src/GameCommon'

const SelectLiveMatchTypePopup: React.FC = () => {
  const { globalStore, chattingStore } = useRootStore()
  const { visibleSelectLiveMatchType } = globalStore
  const { selectedMatchTimeline, registeredMatchTimelineList } = chattingStore

  const sportId = selectedMatchTimeline?.sportId

  const onCloseModal = () => {
    globalStore.setVisibleSelectLiveMatchType(false)
  }

  const onClickSelectFullTimeScore = () => {
    if (isAlreadyRegistered(true)) {
      message.info('이미 추가 되었습니다.')
      return
    }
    chattingStore.registerMatchTimelineWatchingList(selectedMatchTimeline, true)
    onCloseModal()
  }

  const onClickSelectPeriodTimeScore = () => {
    if (isAlreadyRegistered(false)) {
      message.info('이미 추가 되었습니다.')
      return
    }
    chattingStore.registerMatchTimelineWatchingList(selectedMatchTimeline, false)
    onCloseModal()
  }

  const isAlreadyRegistered = (showFullTime) => {
    let result = false
    _.find(registeredMatchTimelineList, item => {
      if (item.matchTimeline
        && item.matchTimeline.matchId === selectedMatchTimeline.matchId
        && item.showFullTime === showFullTime) {
        result = true
      }
    })
    return result
  }

  let typeTitle
  let typeContents

  switch (sportId) {
    case LS_SPORT_ID.FOOTBALL:
    case SPORT_ID.SOCCER:
      typeTitle = '전후반 스코어'
      typeContents = '진행중인 전반전 혹은 후반전 스코어'
      break
    case LS_SPORT_ID.BASKETBALL:
    case SPORT_ID.BASKETBALL:
      typeTitle = '쿼터 스코어'
      typeContents = '진행중인 쿼터 스코어'
      break
    case LS_SPORT_ID.BASEBALL:
    case SPORT_ID.BASEBALL:
      typeTitle = '이닝 스코어'
      typeContents = '진행중인 이닝 스코어'
      break
    case LS_SPORT_ID.ICE_HOCKEY:
    case SPORT_ID.ICE_HOCKEY:
      typeTitle = '피리어드 스코어'
      typeContents = '진행중인 피리어드 스코어'
      break
    case LS_SPORT_ID.VOLLEYBALL:
    case SPORT_ID.VOLLEYBALL:
      typeTitle = '세트 스코어'
      typeContents = '진행중인 세트 스코어'
      break
    default:
      typeTitle = '스코어'
      typeContents = '진행중인 스코어'
      break
  }

  return (
    <Modal
      transparent
      visible={visibleSelectLiveMatchType}
      maskClosable={false}
      onClose={onCloseModal}
      css={AdvDialogStyle}
      className="custom-dialog white-dialog small-size"
      title="타입 선택"
    >
      <SelectTypeModal>
        <Button className="select-type-btn" onClick={onClickSelectFullTimeScore}>
          풀타임 스코어
          <span className="sub-txt">풀타임 기준 전체 스코어</span>
        </Button>
        <Button className="select-type-btn" onClick={onClickSelectPeriodTimeScore}>
          {typeTitle}
          <span className="sub-txt">{typeContents}</span>
        </Button>
      </SelectTypeModal>
      <ModalBg onClick={onCloseModal}/>
    </Modal>
  )
}

export default observer(SelectLiveMatchTypePopup)
